import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getFuelSupplyTypeList as getFuelSupplyTypeListApi,
	getFuelSupplyType as getFuelSupplyTypeApi,
	getFuelSupplyTypeCode as getFuelSupplyTypeCodeApi,
	addNewFuelSupplyType as addNewFuelSupplyTypeApi,
	updateFuelSupplyType as updateFuelSupplyTypeApi,
	deleteFuelSupplyType as deleteFuelSupplyTypeApi,
} from '../../helpers/establishment/backend_helper';

export const getFuelSupplyTypeList = createAsyncThunk('fuelSupplyType/getFuelSupplyTypeList', async (params) => {
	try {
		const response = getFuelSupplyTypeListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFuelSupplyType = createAsyncThunk('fuelSupplyType/getFuelSupplyType', async fuelSupplyType_id => {
	try {
		const response = getFuelSupplyTypeApi(fuelSupplyType_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const getFuelSupplyTypeCode = createAsyncThunk('fuelSupply/getFuelSupplyTypeCode', async code => {
	try {
		const response = getFuelSupplyTypeCodeApi(code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewFuelSupplyType = createAsyncThunk('fuelSupplyType/addNewFuelSupplyType', async fuelSupplyType => {
	try {
		const response = addNewFuelSupplyTypeApi(fuelSupplyType);
		toast.success('Tipo de Movimiento de Combustible agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar fuelSupplyType.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateFuelSupplyType = createAsyncThunk('fuelSupplyType/updateFuelSupplyType', async (fuelSupplyType) => {
		try {
			const response = updateFuelSupplyTypeApi(fuelSupplyType);
			toast.success('Tipo de Movimiento de Combustible actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar fuelSupplyType.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteFuelSupplyType = createAsyncThunk('fuelSupplyType/deleteFuelSupplyType', async fuelSupplyType => {
	try {
		const response = await deleteFuelSupplyTypeApi(fuelSupplyType);
		toast.success('Tipo de Movimiento de Combustible eliminado exitosamente.', { autoClose: 3000 });
		return { fuelSupplyType, ...response };
	} catch (error) {
		toast.error('Error al eliminar fuelSupplyType.', { autoClose: 3000 });
		throw new Error(error);
	}
});


